import clsx from 'clsx'
import React, { FC, PropsWithChildren, useContext } from 'react'

import SvgClubTrendhim from '@Assets/SVG/ClubTrendhim'
import { SideCartContext } from '@Domains/Cart/Context/SideCartContextProvider'
import { useClub } from '@Domains/Club/Hook'
import { useTranslation } from '@Globals/Translations'

import styles from './ClubSignUpBanner.module.scss'

export interface ClubSignUpBannerProps {
  className?: string
  showJoin?: boolean
  showLogin?: boolean
}

export const ClubSignUpBanner: FC<PropsWithChildren<ClubSignUpBannerProps>> = ({ children, className, showJoin = true, showLogin = true }) => {
  const { t, tDanger } = useTranslation()
  const { isLoggedIn, setModalState } = useClub()
  const { cartSummary } = useContext(SideCartContext)

  const showButtons = !isLoggedIn && (showJoin || showLogin)

  return (
    <div className={clsx(styles.clubSignUpBanner, className)}>
      <span className={styles.text}>
        <SvgClubTrendhim />
        {!isLoggedIn && children}
      </span>
      {showButtons && (
        <div className={styles.buttons}>
          {showJoin && (
            <button
              className={styles.join}
              onClick={() => setModalState('EMAIL_DECISION')}
              type="button"
            >
              {t('common:TRENDHIMCLUB_JOIN_LABEL', 'JOIN')}
            </button>
          )}
          {showLogin && (
            <button
              className={styles.login}
              onClick={() => setModalState('EMAIL_DECISION')}
              type="button"
            >
              {t('common:TRENDHIMCLUB_LOG_IN_LABEL', 'LOGIN')}
            </button>
          )}
        </div>
      )}
      {isLoggedIn && (
        <p className={styles.balance} {...tDanger('common:TRENDHIMCLUB_AVAILABLE_CASHBACK_AMOUNT', { amount: cartSummary?.club?.balance?.format || 0 })} />
      )}
    </div>
  )
}

